import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 嵌套css
import '@/assets/util/nestingCss.css'

// element ui 引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// vxe-table
// import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

// Vue.prototype.$VXETable = VXETable

// echarts 图表
import echarts from 'echarts'
import 'echarts/map/js/world'

// echarts 页面适配    ====↓↓↓↓↓↓↓↓↓↓========
// 定义全局指令
Vue.directive('resize', { // 使用局部注册指令的方式
    // 指令的名称
    bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '',
            height = '';

        function isResize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
                binding.value(); // 关键
            }
            width = style.width;
            height = style.height;
        }

        el.__vueSetInterval__ = setInterval(isResize, 300);
    },
    unbind(el) {
        clearInterval(el.__vueSetInterval__);
    }
})

// 全局使用 echarts 图表
Vue.prototype.$echarts = echarts;

// 自适应
import '@/assets/util/flexible'

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
